import React, { useEffect, useState } from 'react';
import Accordian from 'atoms/Accordian/Accordian';
import { getFormatFromUnix } from 'common/utilities/dayJsUtils';
import ORDER_HISTORY from '../Constants/Constants';
import _first from 'lodash/first';
import _get from 'lodash/get';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useSelector, useDispatch } from 'react-redux';
import { getAndCheck, getFilteredItems } from 'common/utilities/utils';
import { setAddHopeCarryBagInfo } from 'organisms/PaymentProcess/Presentation/orderReceivedScreenFn';
import LookUpMap from '../../FooterComponent/Presentation/LookupMap';
import { getTendersContent } from '@kfc-global/react-shared/redux/Actions/PaymentsContentAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const ReceiptComponent = props => {
  const { orderItem } = props;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { currencySymbol, currencyConversionFactor, addHope, carryBag } = tenantReducer || {};
  const { tendersContent } = useSelector(data => data.paymentsContentReducer);
  const { items: paymentItem = [] } = tendersContent;
  const { phoneImg, Direction } = IMAGE_PATH;
  const {
    fulfillmentDateTime,
    deliveryAddress,
    store,
    foodLines,
    subTotal,
    total,
    taxLines,
    paymentReferences,
    posOrderId,
    inclusiveTaxTotal,
    additionalChargeLines,
    discountTotal,
    service,
  } = orderItem;

  const { phoneNumber: storePhoneNumber } = store;
  const {
    YOUR_ORDER,
    DELIVER_TO,
    PAYMENT,
    ORDER_FROM,
    GET_DIRECTION,
    TOTAL,
    SUBTOTAL,
    ORDER,
    AT,
    COMPLETED,
    GST,
    DISCOUNT,
    SEARCH_IN_CART,
    LARGE_CARRY_BAG,
    ADD_HOPE_TEXT,
  } = ORDER_HISTORY;
  const dateorder = getFormatFromUnix(fulfillmentDateTime, 'll');
  const Time = getFormatFromUnix(fulfillmentDateTime, 'h:mm A');

  const [carryBagDataExistsId, setCarryBagDataExistsId] = useState('');
  const [addHopeDataExistsId, setAddHopeDataExistsId] = useState('');
  const [addHopeDataPrice, setAddHopeDataPrice] = useState(0);
  const [carryBagDataPrice, setCarryBagDataPrice] = useState(0);
  const [foodLineItem, setFoodLineItem] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getTendersContent({
        object: getCmsClient(),
        contentFull: {
          content_type: 'tenders',
          include: 5,
          select: 'sys.id,fields',
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    let addHopeCarryBag = getAndCheck(addHope, carryBag);
    if (addHopeCarryBag) {
      let setAddHopeObj = { setAddHopeDataExistsId, setAddHopeDataPrice };
      let setCarryBagObj = { setCarryBagDataExistsId, setCarryBagDataPrice };
      setAddHopeCarryBagInfo(
        orderItem,
        addHope,
        carryBag,
        SEARCH_IN_CART,
        setAddHopeObj,
        setCarryBagObj,
        tenantReducer,
      );
      let filteredItems = getFilteredItems(foodLines, addHope, carryBag);
      setFoodLineItem(filteredItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderItem]);

  const getPhoneNum = num => {
    num.substr(0, num.indexOf(' '));
    const Contactnumber = num.substr(num.indexOf(' ') + 1);
    return Contactnumber.slice(0, 3) + '-' + Contactnumber.slice(3, 6) + '-' + Contactnumber.slice(6);
  };

  const getPaymentType = () => {
    const payment = _first(paymentReferences, {});
    const paymentType = _first(
      paymentItem.filter(item => item?.fields?.title === payment?.paymentType),
      {},
    );

    return paymentType?.fields?.displayFormat === 'Only image' ? (
      <img src={paymentType?.fields?.icon?.fields?.desktopImage?.fields?.file?.url} alt='paymentMethod' />
    ) : (
      <span className='dateCompleted'>{paymentType?.fields?.displayName}</span>
    );
  };

  const currencyConversion = amount => {
    return (amount / currencyConversionFactor).toFixed(2);
  };

  const getDescription = data => {
    const modGroups = _get(data, 'modGrps', []);
    const modifiersDetails = modGroups.map(o => o.modifiers).flat();
    return modifiersDetails.map(item => `${item.quantity}x ${item.name}`).join();
  };

  return (
    <div>
      <div className='reciept-header'>
        <span className='your-order'>{translateWithI18Next(YOUR_ORDER)}</span>
        <span className='receipt-number'>
          {translateWithI18Next(ORDER)}# {posOrderId}
        </span>
      </div>
      <hr className='horizontal-bar' />
      <div className='reciept-order-detail'>
        <div className='reciept-details-heading'>
          <span className='receipt-sub-heading'>{translateWithI18Next(COMPLETED)}</span>
          <span className='receipt-sub-detail'>{dateorder + ` ${translateWithI18Next(AT)} ` + Time}</span>
        </div>
        {deliveryAddress && (
          <div className='reciept-details-heading'>
            <span className='receipt-sub-heading'>{translateWithI18Next(DELIVER_TO)}</span>
            <span className='receipt-sub-detail width-style-lg'>
              {deliveryAddress?.addressLines[2] && <span>{deliveryAddress?.addressLines[2]}, </span>}
              {deliveryAddress?.addressLines[1] && <span>{deliveryAddress?.addressLines[1]}, </span>}
              {deliveryAddress?.addressLines[0] && <span>{deliveryAddress?.addressLines[0]}, </span>}
              {deliveryAddress?.state && <span>{deliveryAddress?.state}, </span>}
              {deliveryAddress?.pinCode && <span>{deliveryAddress?.pinCode}, </span>}
              {deliveryAddress?.country && <span>{deliveryAddress?.country}</span>}
            </span>
          </div>
        )}
        <div className='reciept-details-heading'>
          <span className='receipt-sub-heading'>{translateWithI18Next(PAYMENT)}</span>
          <span className='receipt-sub-detail'>{getPaymentType()}</span>
        </div>
        <div className='reciept-details-heading'>
          <span className='receipt-sub-heading'>{translateWithI18Next(ORDER_FROM)}</span>
          {store !== null && store !== undefined && (
            <span className='receipt-sub-detail width-style-lg'>
              {store.name}
              <br />
              {store?.address?.addressLines}
            </span>
          )}
        </div>
        <div className='CompletedCallAndDirection mt-2' id='DirectionTest'>
          <span> </span>
          <span className='callAndDirection'>
            <span className='KfcphoneNums'>
              <img src={phoneImg} alt='phone' className='KfcphoneIcon' />
              <a href={'tel:' + storePhoneNumber} className='anchorTags'>
                {getPhoneNum(storePhoneNumber)}
              </a>
            </span>

            <span className='KfcphoneNums' id='DirectionClick' onClick={() => setShowMap(true)}>
              <img src={Direction} alt='phone' className='KfcDirectionIcon' />
              {translateWithI18Next(GET_DIRECTION)}
            </span>
          </span>
        </div>
      </div>
      <section className='reciept-accordian'>
        <Accordian header={`${foodLineItem.length} ITEM`} key={`orderItem-${orderItem.id}`}>
          {foodLineItem.map(itemInfo => (
            <section className=''>
              <div className='reciept-order-item'>
                <div className='reciept-item-details'>
                  <div className='item-count-box mr'>
                    <span className='item-count ml'>{itemInfo.quantity}</span>
                  </div>
                  <div className='item-desc-section'>
                    <span className='item-desc'>{itemInfo.item.displayName}</span>
                    <span className='item-desc-quantity'>{getDescription(itemInfo.item)}</span>
                  </div>
                </div>
                <span className='item-amount'>
                  {currencySymbol}
                  {currencyConversion.call(this, itemInfo.item.quantity * itemInfo.item.unitPrice)}{' '}
                </span>
              </div>
            </section>
          ))}
        </Accordian>
      </section>
      <div className='reciept-order-detail'>
        <div className='reciept-payment-details'>
          <span className='payment-type'>{translateWithI18Next(SUBTOTAL)}</span>
          <span className='payment-amount'>
            {currencySymbol}
            {currencyConversion(subTotal)}
          </span>
        </div>
        {taxLines && (
          <div className='reciept-payment-details'>
            <span className='payment-type'>{GST}</span>
            <span className='payment-amount'>
              {currencySymbol}
              {currencyConversion(inclusiveTaxTotal)}
            </span>
          </div>
        )}
        {additionalChargeLines.map((data, idx) => (
          <div key={idx} className='reciept-payment-details'>
            <span className='payment-type'> {data.chargeType}</span>
            <span className='payment-amount'>
              {currencySymbol}
              {currencyConversion.call(this, data.amount)}{' '}
            </span>
          </div>
        ))}
        {discountTotal > 0 && (
          <div className='reciept-payment-details'>
            <span className='payment-type'>{translateWithI18Next(DISCOUNT)}</span>
            <span className='payment-amount'>
              {' '}
              - {currencySymbol}
              {currencyConversion(discountTotal)}
            </span>
          </div>
        )}
        {service.toUpperCase() === 'PICKUP' && carryBagDataExistsId && (
          <div className='reciept-payment-details' id='priceListData'>
            <span className='payment-type' id='fontStyle'>
              {translateWithI18Next(LARGE_CARRY_BAG)}
            </span>
            <span className='payment-amount' id='amountStyle'>
              {carryBagDataPrice}
            </span>
          </div>
        )}
        {Boolean(addHopeDataExistsId) && (
          <div className='reciept-payment-details' id='priceListData'>
            <span className='payment-type' id='fontStyle'>
              {translateWithI18Next(ADD_HOPE_TEXT)}
            </span>
            <span className='payment-amount' id='amountStyle'>
              {addHopeDataPrice}
            </span>
          </div>
        )}
        <div className='reciept-payment-details mt-4'>
          <span className='payment-total'>{translateWithI18Next(TOTAL)}</span>
          <span className='payment-total-amount'>
            {currencySymbol}
            {currencyConversion(total)}
          </span>
        </div>
        {showMap && (
          <div>
            <LookUpMap
              data-testid='map-modal'
              isOpen={showMap}
              handleClose={() => setShowMap(false)}
              OrderReducerData={orderItem}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceiptComponent;
